



































import { Component } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'

interface ModalSelectFormatInterface {
  onNormalDisplay: () => void
  onTwoRowDisplay: () => void
}

@Component({
  components: {
    ModalFooter
  }
})
export default class ModalSelectFormat extends ModalComponentBaseVue {
  dialog: boolean = false

  normalDisplayCallback = () => {}

  twoRowDisplayCallback = () => {}

  open(params: ModalSelectFormatInterface): void {
    this.normalDisplayCallback = params.onNormalDisplay
    this.twoRowDisplayCallback = params.onTwoRowDisplay
    this.dialog = true
  }

  close(): void {
    this.dialog = false
    this.normalDisplayCallback = () => {}
    this.twoRowDisplayCallback = () => {}
  }

  onClickNormalDisplay(): void {
    this.normalDisplayCallback()
    this.close()
  }

  onClickTwoRowDisplay(): void {
    this.twoRowDisplayCallback()
    this.close()
  }
}
